import { querystringify } from 'packages/referral_share/share/util';
import { useCallback } from 'react';
import { closeWebView, openWebView } from '../bridge';
import { captureMessage } from '../slardar';
import useConfig from './useConfig';
export function replaceURL(href: string) {
  try {
    closeWebView();
    openWebView(href);
  } catch (err) {
    captureMessage(new Error('Failed to openWebView immediately after closeWebView'));
  }
}
const only_cash_terms_link = 'https://sf16-draftcdn-sg.ibytedtos.com/obj/ies-hotsoon-draft-sg/tiktok/8eb2c148-b529-4907-be34-cf91434d69e6.html';
const cash_coupon_temrs_link = 'https://sf16-draftcdn-sg.ibytedtos.com/obj/ies-hotsoon-draft-sg/tiktok/daa5d24f-cd65-4535-ab6f-77ebb4721ab7.html';
export default function useOpenView() {
  const {
    query: baseQuery,
    config: {
      couponType,
      rulesLink
    }
  } = useConfig();
  const replaceCardPage = useCallback((extraQuery: {
    [key: string]: string;
  } = {}) => {
    replaceURL(`/activity/armor/card_collection?${querystringify({ ...baseQuery,
      ...extraQuery
    })}`);
  }, [baseQuery]);
  const replaceCardPagePersonal = useCallback((extraQuery: {
    [key: string]: string;
  } = {}) => {
    replaceURL(`/activity/armor/card_collection_personal?${querystringify({ ...baseQuery,
      ...extraQuery
    })}`);
  }, [baseQuery]);
  const openTask = useCallback((extraQuery: {
    [key: string]: string;
  } = {}) => {
    delete baseQuery.module_id;
    openWebView(`/activity/referral/task?${querystringify({ ...baseQuery,
      ...extraQuery
    })}`);
  }, [baseQuery]);
  const replaceTask = useCallback((extraQuery: {
    [key: string]: string;
  } = {}) => {
    replaceURL(`/activity/referral/task?${querystringify({ ...baseQuery,
      ...extraQuery
    })}`);
  }, [baseQuery]);
  const replaceArmorTask = useCallback((extraQuery: {
    [key: string]: string;
  } = {}) => {
    replaceURL(`/activity/armor/referral_v2_task?${querystringify({ ...baseQuery,
      ...extraQuery
    })}`);
  }, [baseQuery]);
  const replaceGiftGivingTask = useCallback((extraQuery: {
    [key: string]: string;
  } = {}) => {
    window.location.replace(`${window.location.origin}` + `/activity/armor/gift_giving?${querystringify({ ...baseQuery,
      ...extraQuery
    })}`);
  }, [baseQuery]);
  const replaceXmasGift = useCallback((extraQuery: Record<string, string> = {}) => {
    replaceURL(`/activity/armor/dollars_xmas?${querystringify({ ...baseQuery,
      ...extraQuery
    })}`);
  }, [baseQuery]);
  const replaceContributeReward = useCallback((extraQuery: {
    [key: string]: string;
  } = {}) => {
    window.location.replace(`${window.location.origin}` + `/activity/armor/contribute_reward?${querystringify({ ...baseQuery,
      ...extraQuery
    })}`);
  }, [baseQuery]);
  const openRules = useCallback((enter_from?: string) => {
    delete baseQuery.hide_nav_bar;
    delete baseQuery.should_full_screen;
    const query = { ...baseQuery
    };

    if (enter_from) {
      query.enter_from = enter_from;
    }

    if (query.region === 'kr') {
      +couponType === 1 ? openWebView(cash_coupon_temrs_link) : openWebView(only_cash_terms_link);
    } else {
      openWebView(rulesLink);
    }
  }, [baseQuery]);
  const openWithdraw = useCallback((query = {}) => {
    openWebView(`/activity/armor/referral_withdraw?${querystringify({ ...baseQuery,
      ...query
    })}`);
  }, [baseQuery]);
  const replaceWithdraw = useCallback((query = {}) => {
    window.location.replace(`${window.location.origin}` + `/activity/armor/referral_withdraw?${querystringify({ ...baseQuery,
      ...query
    })}`);
  }, [baseQuery]);
  const openGiftMainPage = useCallback((query = {}) => {
    openWebView(`/activity/armor/gift_giving?${querystringify({ ...baseQuery,
      ...query
    })}`);
  }, [baseQuery]);
  const openPIPOPage = useCallback((extraQuery: {
    [key: string]: string;
  } = {}) => {
    delete baseQuery.module_id;
    openWebView(`/activity/armor/gift_card_list?${querystringify({ ...baseQuery,
      ...extraQuery
    })}`);
  }, [baseQuery]);
  const openCoupon = useCallback((query = {}) => {
    openWebView(`/activity/armor/referral_coupon?${querystringify({ ...baseQuery,
      ...query
    })}`);
  }, [baseQuery]);
  const openCouponCollection = useCallback((query = {}) => {
    openWebView(`/activity/armor/referral_coupon_collection?${querystringify({ ...baseQuery,
      ...query
    })}`);
  }, [baseQuery]);
  const openMyOffer = useCallback((query = {}) => {
    openWebView(`/activity/armor/referral_my_offer?${querystringify({ ...baseQuery,
      ...query
    })}`);
  }, [baseQuery]);
  const openCouponDetail = useCallback((query = {}) => {
    openWebView(`/activity/armor/referral_coupon_detail?${querystringify({ ...baseQuery,
      ...query
    })}`);
  }, [baseQuery]);
  const openSuperCash = useCallback((prefix: string, query = {}) => {
    openWebView(`https://${prefix}.tiktok.com/tt_armor/referral/redpack?${querystringify({ ...baseQuery,
      ...query
    })}`);
  }, [baseQuery]);
  const openMerchantDetail = useCallback((query = {}) => {
    openWebView(`/activity/armor/referral_merchant_detail?${querystringify({ ...baseQuery,
      ...query
    })}`);
  }, [baseQuery]);
  const openOfferDetail = useCallback((query = {}) => {
    openWebView(`/activity/armor/referral_offer_detail?${querystringify({ ...baseQuery,
      ...query
    })}`);
  }, [baseQuery]);
  const openGiftDetail = useCallback((query = {}) => {
    delete baseQuery.u_code;
    delete baseQuery.gift_token;
    openWebView(`/activity/armor/gift_detail?${querystringify({ ...baseQuery,
      ...query
    })}`);
  }, [baseQuery]);
  const openRecordHistory = useCallback((query = {}) => {
    openWebView(`/activity/armor/referral_record_history?${querystringify({ ...baseQuery,
      ...query
    })}`);
  }, [baseQuery]);
  const openAmbassadorManage = useCallback((query = {}) => {
    openWebView(`/activity/armor/ambassador_manage?${querystringify({ ...baseQuery,
      ...query
    })}`);
  }, [baseQuery]);
  const openGiftGivingPage = useCallback((query = {}) => {
    openWebView(`/activity/armor/gift_giving?${querystringify({ ...baseQuery,
      ...query
    })}`);
  }, [baseQuery]);
  const openMyPocketPage = useCallback((query = {}) => {
    delete baseQuery.u_code;
    delete baseQuery.gift_token;
    openWebView(`/activity/armor/my_pockets?${querystringify({ ...baseQuery,
      ...query
    })}`);
  }, [baseQuery]);
  const openInvite = useCallback((query = {}) => {
    openWebView(`/activity/armor/referral_v2_invite?${querystringify({ ...baseQuery,
      ...query
    })}`);
  }, [baseQuery]);
  const openTributeList = useCallback((query = {}) => {
    openWebView(`/activity/armor/invite_tribute_list?${querystringify({ ...baseQuery,
      ...query
    })}`);
  }, [baseQuery]);
  const openDonation = useCallback((query = {}) => {
    openWebView(`/activity/referral/donation?${querystringify({ ...baseQuery,
      ...query
    })}`);
  }, [baseQuery]);
  return {
    openTask,
    openRules,
    openWithdraw,
    openCoupon,
    openCouponCollection,
    openMyOffer,
    openCouponDetail,
    openSuperCash,
    openMerchantDetail,
    openOfferDetail,
    openRecordHistory,
    openAmbassadorManage,
    replaceCardPage,
    replaceCardPagePersonal,
    replaceTask,
    openMyPocketPage,
    openGiftMainPage,
    openGiftGivingPage,
    openGiftDetail,
    openDonation,
    replaceArmorTask,
    replaceWithdraw,
    replaceGiftGivingTask,
    replaceXmasGift,
    replaceContributeReward,
    openInvite,
    openTributeList,
    openPIPOPage
  };
}